import { baseApi } from '@store/baseApi';
import type { PayerStatsResponse } from '@store/generated/patient-coverage';

// Billing surfaces filter by the payer a claim was SUBMITTED under, so their
// dropdown options come from /billing/v2/payer-options — the union of
// current-coverage payers AND payers historical claims were submitted under
// (DOS payer identity). That endpoint is generated and re-exported as
// `useBillingPayerOptionsQuery` from the billing store; import it from there.
//
// The patients payer-stats endpoint below keeps answering "who holds what
// today" and stays in use on the patients page.
const payerStatsApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    getPayerStats: builder.query<PayerStatsResponse, void>({
      query: () => ({ url: '/v2/provider/patients/payer-stats' }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetPayerStatsQuery: usePayerStatsQuery } = payerStatsApi;
